<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $t('heading') }}
      </h1>
      <VCard>
        <VList
          v-if="users && !users.length"
          two-line
          subheader
        >
          <VListTile avatar>
            <VListTileContent>
              <VListTileTitle> {{ $t('noInfoYet') }}</VListTileTitle>
            </VListTileContent>
          </VListTile>
        </VList>

        <VList
          v-else
          two-line
        >
          <template v-for="(item, index) in users">
            <VListTile
              :key="item.id"
              class="mx-2"
            >
              <VListTileContent>
                <VListTileTitle>
                  {{ `${item.first_name} ${item.last_name}` }}
                </VListTileTitle>
                <VListTileSubTitle> {{ $t('userId') }}: {{ item.id }}</VListTileSubTitle>
                <VListTileSubTitle> {{ $t('userEmail') }}: {{ item.email }}</VListTileSubTitle>
              </VListTileContent>
              <VListTileAction>
                <VBtn
                  icon
                  ripple
                  @click="toggleUser(item)"
                >
                  <VIcon :color="isBlocked(item) ? 'red' : 'green'">
                    {{ isBlocked(item) ? 'lock' : 'lock_open' }}
                  </VIcon>
                </VBtn>
              </VListTileAction>
            </VListTile>
            <VDivider
              v-if="index + 1 < users.length"
              :key="'divider-' + item.id"
            />
          </template>
        </VList>

        <Pagination
          ref="usersPagination"
          :url="url"
          @fetchedData="data => users = data"
        />

        <VCardActions>
          <VSpacer />
          <UsersCreateAdmin @onSuccess="update" />
        </VCardActions>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import Pagination from '@/components/global-components/pagination/Pagination'
import UsersCreateAdmin from '@/components/routes/users/UsersCreateAdmin'
import AdminApi from '@/api/AdminApi'

export default {
  name: 'Users',
  components: { UsersCreateAdmin, Pagination },
  props: ['agencyId'],
  data () {
    return {
      url: `users`,
      isLoading: false,
      users: []
    }
  },
  methods: {
    isBlocked (item) {
      return item.status.name === 'blocked'
    },
    async toggleUser (item) {
      try {
        if (this.isBlocked(item)) {
          this.$notification(await AdminApi.enableUser(item.id))
        } else {
          this.$notification(await AdminApi.disableUser(item.id))
        }
      } catch (e) {
        this.$notification(e)
      }
      this.update()
    },
    update () {
      this.$refs.usersPagination.getPaginatedData()
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Benutzerübersicht',
        noInfoYet: 'Benutzerdaten werden geladen...',
        userEmail: 'Email',
        userId: 'ID'
      },
      en: {
        heading: 'User overview',
        noInfoYet: 'Loading user data ...',
        userEmail: 'Email',
        userId: 'ID'
      }
    }
  }
}
</script>
